import { render, staticRenderFns } from "./ThePayment.vue?vue&type=template&id=562f0709&"
import script from "./ThePayment.vue?vue&type=script&lang=js&"
export * from "./ThePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports